import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Image from "../components/image";

const Wrapper = styled.div`
  width: calc(100% / 3);
  position: relative;
  min-height: 430px;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    width: calc(100% / 2);
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: 100%;
    min-height: 330px;
  }
`;
const EmployeeImage = styled(Image)`
  width: 100%;
  height: 315px;
  object-fit: cover;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    height: 375px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    height: 213px;
  }
`;
const Name = styled.p`
  font-size: 1.1rem;
  margin-bottom: 5px !important;
`;
const Text = styled.p`
  font-size: 0.8rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 0.9rem;
  }
`;
const TextOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--color-primary);
  color: var(--color-white);
  font-family: ${({ theme }) => theme.typography.fontFamily};
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 1.5rem 2rem;
  p {
    width: auto;
    margin: 2px 0;
  }
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const StyledExternalLink = styled.a`
  font-size: 0.8rem;
  color: var(--color-white);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 0.9rem;
  }
`;

export default function EmployeeCard({
  image,
  imgUrl,
  imgAlt,
  title,
  name,
  city,
  email,
  phone,
}) {
  return (
    <Wrapper>
      <EmployeeImage image={image} alt={imgAlt} src={imgUrl} />
      <TextOverlay>
        <Name>{name}</Name>
        <Text>
          {title} - {city}
        </Text>
        <Row>
          <StyledExternalLink href={"mailto:" + email}>
            {email}
          </StyledExternalLink>
          <StyledExternalLink href={"tel:" + phone}>{phone}</StyledExternalLink>
        </Row>
      </TextOverlay>
    </Wrapper>
  );
}
EmployeeCard.propTypes = {
  image: PropTypes.object,
  imgUrl: PropTypes.object,
  imgAlt: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  city: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
};

EmployeeCard.defaultProps = {
  image: undefined,
  imgUrl: undefined,
  imgAlt: undefined,
  title: undefined,
  name: undefined,
  city: undefined,
  email: undefined,
  phone: undefined,
};
